export const GET_CART= 'GET_CART'
export const GET_CART_SUCCESS= 'GET_CART_SUCCESS'
export const GET_CART_ERROR='GET_CART_ERROR'

export const GetCart= (data) => ({
    type: GET_CART,
    payload: data
});
